import React from 'react';

interface IFillMenuIcon {
    icon: string;
}

export class FillMenuIcon extends React.Component<IFillMenuIcon, any> {
    render() {
        return <div style={{
            width: 20,
            height: 20,
            position: 'relative',
            marginRight: 8,
        }}>
            <img
                style={{
                    position: 'absolute',
                    width: 15,
                    height: 15,
                    top: 3,
                    left: 2.5,
                }}
                src={this.props.icon}/>
        </div>;
    }
}
